<ul class="list-group identification-list">
    @for (ident of identifications; track ident.id; let index = $index) {
        <li class="list-group-item">
            @if (!ident.editing) {
                <span class="material-icons icon" [ngClass]="{'primary': ident.primary}">{{identIcon(ident.identificationTypeId)}}</span>
                <div class="meta" (click)="editIdentification($event, index)">
                    <p class="title">{{ident.number}}</p>
                    <p class="subtitle">{{ident.issuer}} {{typeDisplay(ident.identificationTypeId)}}</p>
                </div>
                <div class="actions actions-1">
                    <span class="dripicons-trash text-danger" (click)="discardIdentification($event, index)"></span>
                </div>
            }
            @else {
                <form [formGroup]="identificationEdit">
                    <div class="form-row">
                        <div class="form-group col">
                            <select class="form-control form-control-sm" formControlName="identificationTypeId">
                                @for (type of identificationTypes; track type.id) {
                                    <option value="{{type.id}}">{{type.type}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col">
                            <select class="form-control form-control-sm" formControlName="issuer">
                                @for (issuer of identificationIssuers; track issuer.abbreviation) {
                                    <option value="{{issuer.abbreviation}}">{{issuer.name}} ({{issuer.abbreviation}})</option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col">
                            <input type="text" class="form-control form-control-sm" formControlName="number" placeholder="number" />
                        </div>
                        <div class="form-group col">
                            <input type="date" class="form-control form-control-sm" formControlName="expirationDate" placeholder="expires" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-check col">
                            <input type="checkbox" id="identificationPrimary" class="form-check-input" formControlName="primary" />
                            <label class="form-check-label" for="identificationPrimary">Primary</label>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="actions col">
                            <button type="button" class="btn btn-sm btn-link" (click)="cancelIdentification($event)"><span class="text-danger">cancel</span></button>
                            <button type="button" class="btn btn-sm btn-primary" (click)="saveIdentification($event)">Save</button>
                        </div>
                    </div>
                </form>
            }
        </li>
    }
</ul>
<button (click)="addIdentification($event)" title="Add Identification" class="btn btn-sm btn-success add"><span class="uil-plus"></span></button>